var f = Object.defineProperty;
var L = (e, t, o) => t in e ? f(e, t, { enumerable: !0, configurable: !0, writable: !0, value: o }) : e[t] = o;
var B = (e, t, o) => (L(e, typeof t != "symbol" ? t + "" : t, o), o);
import { GeoJsonLayer as R, PathLayer as T } from "@deck.gl/layers/typed";
import { hexToRGB as x } from "@placer-ui/components";
import { getDeckPolygonOffset as A } from "./index.es420.js";
class W extends R {
  renderLayers() {
    const t = this.getSubLayerProps({
      id: "line"
    }), o = new Set(this.props.roadType), i = this.props.userInputRange, a = this.props.hoveredFeatureId, n = this.props.visibleItems, u = this.state.layerProps.lines.data, c = this.state.layerProps.lines.getPath, d = k, h = this.props.getCarVolumePerDayAtoB || F, p = this.props.getCarVolumePerDayBtoA || j, y = this.props.getSegmentId || O, m = this.props.getRoadType || I;
    return [
      new T({
        ...t,
        id: `${t.id}-outer`,
        data: u,
        getPath: c,
        pickable: !1,
        getColor: (s) => {
          const r = d(s), g = h(r) || 0, l = p(r) || 0, P = m(r), D = y(r);
          return C({
            segmentId: D,
            carVolumePerDay: g + l,
            roadType: P,
            hoveredFeatureId: a,
            roadTypesToShow: o,
            userInputRange: i,
            visibleItems: n,
            pathType: "outer"
          });
        },
        getWidth: (s) => {
          const r = d(s), g = h(r) || 0, l = p(r) || 0;
          return V({
            carVolumePerDay: g + l,
            visibleItems: n,
            pathType: "outer"
          });
        },
        widthUnits: "pixels",
        capRounded: !0,
        jointRounded: !0,
        updateTriggers: {
          getWidth: [i, n],
          getColor: [a, o, i, n]
        },
        getPolygonOffset: ({ layerIndex: s }) => A("vtv", s)
      }),
      new T({
        ...t,
        id: `${t.id}-inner`,
        data: u,
        getPath: c,
        getColor: (s) => {
          const r = d(s), g = h(r) || 0, l = p(r) || 0, P = m(r), D = y(r);
          return C({
            segmentId: D,
            carVolumePerDay: g + l,
            roadType: P,
            hoveredFeatureId: a,
            roadTypesToShow: o,
            userInputRange: i,
            visibleItems: n,
            pathType: "inner"
          });
        },
        getWidth: (s) => {
          const r = d(s), g = h(r) || 0, l = p(r) || 0;
          return V({
            carVolumePerDay: g + l,
            visibleItems: n,
            pathType: "inner"
          });
        },
        widthUnits: "pixels",
        capRounded: !0,
        jointRounded: !0,
        pickable: t.pickable,
        updateTriggers: {
          getWidth: [i, n],
          getColor: [a, o, i, n]
        },
        getPolygonOffset: ({ layerIndex: s }) => A("vtv", s)
      })
    ];
  }
}
B(W, "layerName", "PLVehicleTrafficVolumeLayer");
const w = [0.75, 2, 3, 4.5], S = [0, 2.5, 3.5, 6], V = ({
  carVolumePerDay: e,
  pathType: t,
  visibleItems: o
}) => {
  if (!o || o.length === 0)
    return 0;
  const i = t === "outer" ? S : w;
  for (let a = 0; a < o.length; a++) {
    const n = o[a].ranges;
    if (n) {
      const [u, c] = n;
      if (e >= u && e < c)
        return i[a];
    } else
      return [0, 0, 0, 0];
  }
  return 0;
}, C = ({
  segmentId: e,
  roadType: t,
  carVolumePerDay: o,
  hoveredFeatureId: i,
  roadTypesToShow: a,
  userInputRange: n,
  pathType: u,
  visibleItems: c
}) => {
  if (!c || c.length === 0)
    return [0, 0, 0, 1];
  if (!a.has(t))
    return [0, 0, 0, 0];
  const [d, h] = n;
  if (o < d || o > h)
    return [0, 0, 0, 0];
  if (i === e)
    return [60, 0, 255];
  for (let p = 0; p < c.length; p++) {
    const y = c[p].ranges;
    if (y) {
      const [m, s] = y, r = c[p].visible, g = x(c[p].color);
      if (o >= m && o <= s && r)
        return u === "inner" ? g : [0, 0, 0];
    } else
      return [0, 0, 0, 0];
  }
  return [0, 0, 0, 0];
}, k = (e) => {
  var t;
  return (t = e == null ? void 0 : e.__source) == null ? void 0 : t.object;
}, F = (e) => {
  var t;
  return (t = e == null ? void 0 : e.properties) == null ? void 0 : t.totalCarsPerDayAtoB;
}, j = (e) => {
  var t;
  return (t = e == null ? void 0 : e.properties) == null ? void 0 : t.totalCarsPerDayBtoA;
}, I = (e) => {
  var t;
  return (t = e == null ? void 0 : e.properties) == null ? void 0 : t.roadType;
}, O = (e) => {
  var t;
  return (t = e == null ? void 0 : e.properties) == null ? void 0 : t.id;
};
export {
  W as PLVehicleTrafficVolumePathLayer,
  C as getLineColor
};
//# sourceMappingURL=index.es483.js.map
